import { render, staticRenderFns } from "./LegoLayout.vue?vue&type=template&id=17886248&scoped=true"
import script from "./LegoLayout.vue?vue&type=script&lang=js"
export * from "./LegoLayout.vue?vue&type=script&lang=js"
import style0 from "./LegoLayout.vue?vue&type=style&index=0&id=17886248&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17886248",
  null
  
)

export default component.exports